import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';

class SMFormTextFieldWithError extends SMFormFieldBaseView {

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      value : this.props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      name: nextProps.name,
      value : nextProps.value,
    });
  }

  render() {

    const fieldClassName = this.errorFieldClassName("form-text", this.props.errorText);

    return (
      <div className="form-box">
        <SMFormTextField
          delegate={this.props.delegate}
          name={this.state.name}
          value={this.state.value}
          type={this.props.type}
          placeholderText={this.props.placeholderText}
          className={fieldClassName}
          options={this.props.options}
          placeholder={this.props.placeholderText}
          errorText={this.props.errorText}
        />
        <SMFormValidationMessage name={this.props.name} errorText={this.props.errorText} />
      </div>
    );
  }
}
export default SMFormTextFieldWithError;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormTextFieldWithError.jsx